// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2QuNB","actions":"GroupTable_actions__FWG5h","deleteModalFooter":"GroupTable_deleteModalFooter__DaZnf"};